var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.953 2.52699C23.9335 2.43837 23.891 2.35646 23.8297 2.28955C23.7684 2.22265 23.6906 2.17312 23.604 2.14599C23.2887 2.08354 22.9624 2.10667 22.659 2.21299C22.659 2.21299 1.63 9.77199 0.428998 10.609C0.170998 10.789 0.0839983 10.894 0.0409983 11.017C-0.167002 11.617 0.479998 11.875 0.479998 11.875L5.9 13.641C5.99164 13.6574 6.08588 13.6519 6.175 13.625C7.407 12.846 18.575 5.79099 19.224 5.55399C19.324 5.52399 19.401 5.55399 19.381 5.62899C19.123 6.53399 9.472 15.107 9.419 15.159C9.39318 15.1801 9.37307 15.2074 9.36049 15.2383C9.34792 15.2692 9.34328 15.3028 9.347 15.336L8.841 20.628C8.841 20.628 8.629 22.275 10.276 20.628C11.444 19.459 12.565 18.491 13.125 18.02C14.989 19.307 16.994 20.73 17.859 21.475C18.0045 21.6158 18.1769 21.7259 18.3659 21.7986C18.5549 21.8712 18.7566 21.9051 18.959 21.898C19.2082 21.8676 19.4423 21.7621 19.63 21.5954C19.8178 21.4287 19.9503 21.2088 20.01 20.965C20.01 20.965 23.84 5.54199 23.968 3.47599C23.981 3.27599 23.998 3.14399 24 3.00499C24.0062 2.84426 23.9904 2.68343 23.953 2.52699Z",
    fill: "url(#paint0_linear_52_914)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_914",
    x1: -0.000213292,
    y1: 5.90392,
    x2: 24.0166,
    y2: 5.92692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3416B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45F48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelActive);
export default __webpack_public_path__ + "static/media/tel_active.69593685394691784a63b89885f36ce3.svg";
export { ForwardRef as ReactComponent };